<ion-header class="header ios-notch-top ion-no-border" no-shadow no-border id="main-content">
	<ion-toolbar class="title in-toolbar-color">
		<ion-buttons slot="start">
			<ion-menu-button *ngIf="menuBtnEnabled">
				<ion-icon class="icon-Menu"></ion-icon>
			</ion-menu-button>
			<ion-button *ngIf="backBtnEnabled" (click)="goBack()">
				<ion-icon [ngClass]="!backBtnIconClose ? 'icon-Arrow-Left' : 'icon-Close'"></ion-icon>
			</ion-button>
		</ion-buttons>
		<ion-buttons *ngIf="showSaveBtn" slot="primary">
			<ion-button [disabled]="!saveBtnEnabled" (click)="save()">
				<ion-icon slot="icon-only" class="icon-Check save"></ion-icon>
			</ion-button>
		</ion-buttons>
		<ion-buttons *ngIf="exportEnabled" slot="primary">
			<ion-button (click)="openPopover($event)">
				<ion-icon slot="icon-only" class="icon-More"></ion-icon>
			</ion-button>
		</ion-buttons>

		<ion-title *ngIf="!ellipsisPopoverEnabled" class="ion-text-center">
			{{ headerTitle }}
		</ion-title>

		<ion-title *ngIf="ellipsisPopoverEnabled && headerTitle" class="ion-text-center">
			<span [innerHTML]="headerTitle | slice: 0 : 10 | headerTitleVerticalLine"></span>
			<ng-container *ngIf="headerTitle.length > 10">
				<span class="ellipsis">...</span>
				<ion-button id="ql-header-title" fill="clear" class="ion-no-margin" size="small">
					<ion-text>i</ion-text>
				</ion-button>
				<ion-popover
					class="ql-header-title"
					trigger="ql-header-title"
					side="bottom"
					alignment="center"
					size="auto"
					triggerAction="click"
				>
					<ion-content class="ion-padding" [innerHTML]="headerTitle | headerTitlePopover"></ion-content>
				</ion-popover>
			</ng-container>
		</ion-title>
	</ion-toolbar>
	<ion-toolbar class="subtitle" *ngIf="headerSubtitle">
		<ion-title size="small" class="ion-text-center ion-no-padding">{{ headerSubtitle }}</ion-title>
	</ion-toolbar>
	<ion-toolbar class="subtitle" *ngIf="syncStatus">
		<ion-title size="small" class="status ion-text-center ion-no-padding">{{ syncStatus }}</ion-title>
	</ion-toolbar>
	<app-search-sort-filter *ngIf="searchSortFilterEnabled"></app-search-sort-filter>
</ion-header>
